module.exports = __webpack_public_path__ + "img/11.d87a82d.png";